import React, { FC, useMemo, useRef } from 'react'
import { Center, useRadio } from '@chakra-ui/react'
import { Box, Image, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import { cardImageMap } from '../../state/interfaces'
import { RadioButton } from './radio-button'

export const ImageRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props)
  const inputProps = getInputProps()
  const image = useMemo(() => (props.image ? cardImageMap[props.image] : ''), [props])
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }
  return (
    <Box as="label" cursor="pointer" data-testid={`image-${props.value}`}>
      <Center
        {...getCheckboxProps()}
        border={3}
        borderStyle="solid"
        borderColor="grey"
        width={['256px', '350px']}
        padding={4}
        fontWeight="bold"
        fontSize="xs"
        borderRadius="xl"
        whiteSpace="normal"
        margin={2}
        flexDirection="column"
        textAlign="center"
        aria-label={`button-${props.label}`}
        _hover={{
          borderColor: 'brand',
        }}
        _checked={{
          borderColor: 'brand',
        }}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
        onFocus={handleFocus}
        tabIndex={0}
      >
        <RadioButton {...inputProps} ref={inputRef} />
        <Image
          src={image}
          alt={`icon-${props.value}`}
          padding={2}
          borderRadius={4}
          width={['50%', '75%']}
          height={['50%', '75%']}
        />
        <Text marginTop={4}>{props.label}</Text>
      </Center>
    </Box>
  )
}
